var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTestdrive = function SvgTestdrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 9.785A8.717 8.717 0 0 1 10 1.035c4.865 0 8.75 3.996 8.75 8.75a8.717 8.717 0 0 1-8.75 8.75 8.717 8.717 0 0 1-8.75-8.75ZM10 2.535c-4.03 0-7.25 3.22-7.25 7.25 0 4.03 3.22 7.25 7.25 7.25 4.03 0 7.25-3.22 7.25-7.25 0-3.937-3.226-7.25-7.25-7.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95 9.555a.75.75 0 0 1 .75-.75h14.7a.75.75 0 0 1 0 1.5h-3.109c-.338 2.13-2.095 3.78-4.291 3.78s-3.953-1.65-4.291-3.78H2.7a.75.75 0 0 1-.75-.75Zm5.286.75c.313 1.337 1.447 2.28 2.764 2.28 1.317 0 2.451-.943 2.764-2.28H7.236Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgTestdrive;